// extracted by mini-css-extract-plugin
export default {"body":"AssetMetadata_body__z3v7S"};